import type {
  DisplayConfig,
  DisplayConfigValues,
} from 'src/types/display-config';

import {useSelector} from 'react-redux';

import {
  selectDisplayConfigByKey,
  selectAbtEnabled,
  selectJ2Enabled,
  selectJourneysEnabled,
} from 'src/selectors/display-config';


type UseDisplayConfig = (key: string) => DisplayConfigValues;
/*
 * ```
 * useDisplayConfig().displayConfigKey;
 * ```
 * This ensures you get the correct flag Flow type.
 */
// @ts-expect-error - TS2322 - Type '(key: string) => DisplayConfig' is not assignable to type 'UseDisplayConfig'.
const useDisplayConfig: UseDisplayConfig = function useDisplayConfig(key) {
  const displayConfig = useSelector((state) =>
    selectDisplayConfigByKey(state, key),
  );
  return displayConfig;
};

//NOTE:(diwakersurya) this includes OR|NOT Rules and multiple list mapping
export const useAudienceListPowerFeatures = (): DisplayConfigValues => {
  return useDisplayConfig('list_power_features_enabled');
};
export const useAbtEnabled = (): DisplayConfigValues => {
  const isAbtEnabled = useSelector((state) => selectAbtEnabled(state));
  // @ts-expect-error - TS2322 - Type 'DisplayConfig' is not assignable to type 'DisplayConfigValues'.
  return isAbtEnabled;
};
export const useJ2Enabled = (): DisplayConfigValues => {
  // @ts-expect-error - TS2322 - Type 'DisplayConfig' is not assignable to type 'DisplayConfigValues'.
  return useSelector(selectJ2Enabled);
};

export const useJourneysEnabled = (): DisplayConfigValues => {
  // @ts-expect-error - TS2322 - Type 'DisplayConfig' is not assignable to type 'DisplayConfigValues'.
  return useSelector(selectJourneysEnabled);
};

export default useDisplayConfig;
